import { render, staticRenderFns } from "./regionalQuestion.vue?vue&type=template&id=27169087&scoped=true&"
import script from "./regionalQuestion.vue?vue&type=script&lang=js&"
export * from "./regionalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./regionalQuestion.vue?vue&type=style&index=0&id=27169087&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27169087",
  null
  
)

export default component.exports